define('cartware/dom/event/trigger',[],function() {
	var eventPrefix = "on";

	return function triggerEvent(element, type, options) {
		if ("undefined" !== typeof jQuery && element instanceof jQuery) {
			return element.each(function() {
				triggerEvent(this, type, options);
			});
		}

		if (element === undefined) {
			throw new Error("Parameter cannot be undefined");
		}

		if (!options) {
			options = {};
		}

		var o = {
			type: type,
			view: options.view || element.ownerDocument.defaultView,
			detail: options.detail || 1,
			screenX: options.screenX || 0,
			screenY: options.screenY || 0,
			clientX: options.clientX || 0,
			clientY: options.clientY || 0,
			button: options.button || 0,
			ctrlKey: options.ctrlKey || false,
			altKey: options.altKey || false,
			shiftKey: options.shiftKey || false,
			metaKey: options.metaKey || false,
			bubbles: options.bubbles || true,
			cancelable: options.cancelable || true
		};

		var props = {
			which: options.which || null
		};

		var eventObjects = {
			'HTMLEvents': /^(?:load|unload|abort|error|select|change|submit|reset|focus|blur|resize|scroll)$/,
			'MouseEvents': /^(?:click|dblclick|mouse(?:down|up|over|move|out))$/
		};
		var eventClass = 'Event';
		var event;

		for (var name in eventObjects) {
			if (!eventObjects.hasOwnProperty(name)) continue;
			if (eventObjects[name].test(type)) { eventClass = name; break; }
		}

		if (document.createEvent) {
			event = element.ownerDocument.createEvent(eventClass);
			if (eventClass == 'MouseEvents') {
				event.initMouseEvent( o.type, o.bubbles, o.cancelable, o.view,
					o.detail, o.screenX, o.screenY, o.clientX, o.clientY, o.ctrlKey,
					o.altKey, o.shiftKey, o.metaKey, 0, null);
			} else {
				event.initEvent(type, o.bubbles, o.cancelable);
			}
			for (var key in props) {
				if (!props.hasOwnProperty(key)) continue;
				event[key] = props[key];
			}
			element.dispatchEvent(event);
		} else if (document.createEventObject) {
			o.clientX = o.pointerX;
			o.clientY = o.pointerY;
			event = document.createEventObject();
			for (var key in o) {
				if (!o.hasOwnProperty(key)) continue;
				event[key] = o[key];
			}
			element.fireEvent(eventPrefix + type, event);
		}

		return event;
	}
});
